// Hosts an app is built not to reach (`swiftbrowser build --block-host
// <host>`): a request to one of them, or to a subdomain, fails at once as if
// the network were down, without leaving the page. For a public deploy of
// an app whose analytics or other services belong to someone else (Ice Cubes'
// TelemetryDeck signals): the app keeps working, those requests do not go out.

/** Whether `url` is on one of `hosts` (or a subdomain of one). */
import type { FetchLike } from './hostRequests';

export function isBlocked(url: string, hosts: readonly string[]): boolean {
  let host: string;
  try {
    host = new URL(url).hostname.toLowerCase();
  } catch {
    return false;
  }
  return hosts.some((blocked) => {
    const name = blocked.toLowerCase();
    return host === name || host.endsWith(`.${name}`);
  });
}

/** `fetchImpl`, failing requests to `hosts` as a network error does. */
export function withBlockedHosts(fetchImpl: FetchLike, hosts: readonly string[]): FetchLike {
  if (hosts.length === 0) return fetchImpl;
  return async (input, init) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    if (isBlocked(url, hosts)) throw new TypeError(`Failed to fetch: ${new URL(url).hostname} is blocked in this build`);
    return fetchImpl(input, init);
  };
}
